import { useCallback, useState } from 'react';
import { type GenericPointFeature, type LngLat } from '@yandex/ymaps3-types';
import { type Nullable } from '@direct-frontend/stdlib';
import { type PickupPoint } from '@/shared/api/pickupPoint';
import { usePickupAddressContext } from '../../../../PickupAddressContext';

export const useClusterMenu = () => {
    const [coordinates, setCoordinates] = useState<Nullable<LngLat>>(null);
    const [points, setPoints] = useState<Nullable<Array<PickupPoint>>>(null);

    const { pickupPoints } = usePickupAddressContext();

    const handleChangeMenu = useCallback(
        (features: Array<GenericPointFeature<LngLat>>) => {
            const ids = new Set(features.map((feature) => feature.id));

            const points = pickupPoints.filter((point) => ids.has(point.id));

            if (!points.length) {
                return;
            }

            setPoints(points);

            const { longitude, latitude } = points[0].position;

            setCoordinates([longitude, latitude]);
        },
        [pickupPoints]
    );

    const handleCloseMenu = useCallback(() => {
        setPoints(null);
        setCoordinates(null);
    }, []);

    return {
        handleChangeMenu,
        handleCloseMenu,
        menuCoordinates: coordinates,
        menuPoints: points,
    };
};
